import * as R from 'ramda'

/**
 * Filter options/rules share a base `field` (e.g. `collaborator`, `customer.attribute`)
 * and a discriminator carried under `extra.attribute` or `extra.role` to disambiguate
 * sibling options that target the same backend field. Helpers below centralize that
 * discriminator contract so adding a third slot is a one-line change here instead of
 * a sweep across every caller.
 */

export function getOptionDiscriminator(extra) {
  if (!extra) {
    return ''
  }
  return extra.attribute || extra.role || ''
}

export function getRuleDiscriminator(rule) {
  return R.path(['extra', 'attribute'], rule) || R.path(['extra', 'role'], rule) || ''
}

export function getFlatRuleDiscriminator(rule) {
  return R.prop('attribute', rule) || R.prop('role', rule) || ''
}

export function buildExtraFromFlatRule(rule) {
  if (R.prop('attribute', rule)) {
    return { attribute: rule.attribute }
  }
  if (R.prop('role', rule)) {
    return { role: rule.role }
  }
  return null
}

export function getExtraSlots(extra) {
  if (!extra) {
    return {}
  }
  if (extra.attribute) {
    return { attribute: extra.attribute }
  }
  if (extra.role) {
    return { role: extra.role }
  }
  return {}
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/filter-rule-discriminator/index.js